import PouchDB from 'pouchdb-browser';
import { COUCH_URL, COUCH_DATABASE } from "./constants";
 
export const db = new PouchDB('sagiper');
export const remoteDatabase = new PouchDB(`${COUCH_URL}/${COUCH_DATABASE}`);

PouchDB.sync(db, remoteDatabase, {
    live: true,
    heartbeat: false,
    timeout: false,
    retry: true
});